import { LOGIN_USER } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isLoadingBack: false,
  token: "",
  loginUserDetails: {},
  loginError: {
    isLoginError: false,
    errorMsg: ''
  }
};

const loginSlice = createSlice({
  name: LOGIN_USER,
  initialState,
  reducers: {
    login: (state, { payload }) => {
      state.token = payload.token;
      state.loginUserDetails = payload.loginUserDetails;
    },
    updateLoadingState: (state, { payload }) => {
      state.isLoadingBack = payload.isLoadingBack;
    },
    setLoginError: (state, { payload }) => {
      state.loginError.isLoginError = true;
      state.loginError.errorMsg = payload;
    },
    clearLoginError: (state) => {
      state.loginError.isLoginError = false;
      state.loginError.errorMsg = '';
    },
    reset: () => { },
  },

  // extraReducers: (builder) => {
  //   builder.addCase(loginUser.pending, (state) => {
  //   });
  //   builder.addCase(loginUser.fulfilled, (state, { payload }) => {

  //   });
  //   builder.addCase(loginUser.rejected, (state) => {

  //   });
  // },
});
export const LoginActions = loginSlice.actions;
export default loginSlice.reducer;
